/**
 * File Name          : response-result.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

export enum RESULT_CODE {
 SUCCESS = 0x00,
 FAIL = 0x01,
 BUSY = 0x02,
 INCOMPLETE = 0x03,
 UNAUTHORIZED = 0x04,
 NACK = 0x05,
 NA      = 0xFF,
};